import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import ManagerCalendarView from "../CRUD/ManageBookings/ManagerCalendarView";
const ManagerCalendarViewWrapper = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const fetchEvents = useCallback(async (startDate: Date, endDate: Date) => {
    try {
      const response = await axios.get(`${apiUrl}/PackageBooking/individualBookings`, {
        params: {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          _t: Date.now(),
        },
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      });
      const bookings: any[] = response.data as any[];
      const calendarEvents = bookings.map((b: any) => ({
        
        id: b.bookingId,
        orderNumber: b.orderNumber,
        blockedChaletsCount: b.blockedChaletsCount,
        price: b.totalCost,
        chaletId: b.chaletId,
        chaletType: b.chaletType,
        bookingDescription: b.bookingDescription,
        isBusinessUser: b.isBusinessUser,
        preBooking: b.isBusinessUser ? b.preBooking : null, // Only set preBooking if isBusinessUser is true
        title: `${b.packageName} - ${b.isBusinessUser ? "Business" : "Individual"}`, // Update title
        start: b.arrivalDate,
        end: b.departureDate,
        backgroundColor: (String(b.chaletType).toLowerCase() === "big" || b.chaletType === 0) ? "#6a9ab1" : "#ff626f",
        borderColor: (String(b.chaletType).toLowerCase() === "big" || b.chaletType === 0) ? "#003366" : "#004d40", // Differentiate border color
        extendedProps: {
          details: b,
          description: `${b.blockedChaletsCount}`,
          price: b.totalCost, // Add price to extendedProps
          preBooking: b.isBusinessUser ? b.preBooking : null, // Add preBooking status to extendedProps
        },
        allDay: true,
        clickable: false,
      }));
      setEvents(calendarEvents);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    const startDate = new Date(); // Set your desired start date
    const endDate = new Date();
    endDate.setDate(startDate.getDate() + 30); // Set your desired end date (e.g., 30 days from start date)
    fetchEvents(startDate, endDate);
  }, [fetchEvents]);

  const handleEventChange = () => {
    const startDate = new Date(); // Set your desired start date
    const endDate = new Date();
    endDate.setDate(startDate.getDate() + 30); // Set your desired end date (e.g., 30 days from start date
    setLoading(true);
    fetchEvents(startDate, endDate);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return <ManagerCalendarView events={events} onEventChange={handleEventChange} />;
};

export default ManagerCalendarViewWrapper;